module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_01-3936e671d5c01c22ab3275fc361cfbd5.webp";